
# RenderStats =
#   beforeCreate: ->
#     window.global_stats ||= {}
#     window.global_stats[@$options.name] ||= {
#       all: []
#       average: 0
#     }
#     @_RenderStats = performance.now()
#   mounted: ->
#     obj = window.global_stats[@$options.name]
#     time = performance.now() - @_RenderStats
#     obj.all.push time
#     obj.average = Math.round(_.sumBy(obj.all) / obj.all.length)
#     # if time > 20
#     #   log.box "⏰ #{@$options.name}: #{time}"
# Vue.mixin RenderStats

module.exports =
  name: 'app'
  metaInfo:
    # title: 'HoneyMoney'
    titleTemplate: (titleChunk = '') -> "#{titleChunk} - #{@$t('HoneyMoney')}".trim()
  data: ->
    refreshing: false
    registration: null
    update_exists: false
  created: ->
    if HM.is_mobile && !location.pathname.includes('mobile') && !location.pathname.includes('sign_up')
      HM.router.replace({ path: '/app/mobile/transactions/calendar' })
    if !HM.is_mobile && location.pathname.includes('mobile')
      HM.router.replace({ path: '/app/my/transactions/calendar' })
    # https://medium.com/@dougallrich/give-users-control-over-app-updates-in-vue-cli-3-pwas-20453aedc1f2
    return unless navigator.serviceWorker
    document.addEventListener 'swUpdated', @showRefreshUI, { once: true }
    navigator.serviceWorker.addEventListener 'controllerchange', =>
      return if @refreshing
      @refreshing = true
  computed:
    display_update_bar: -> @update_exists && @$router.currentRoute.name != 'changelog_page'
  methods:
    showRefreshUI: (e) ->
      @registration = e.detail
      @update_exists = true
    refreshApp: ->
      setTimeout (-> location.reload()), 500
      @update_exists = false
      return if !@registration || !@registration.waiting
      @registration.waiting.postMessage('skipWaiting')
